// extracted by mini-css-extract-plugin
export default {"container":"Message_container__GCM5K","message":"Message_message__VSP18"};